<template>
  <b-container fluid class="h-100 px-0" style="min-height: 100vh">
    <div
      :class="['content-login', 'h-100', fontClass]"
      style="min-height: 100vh"
    >
      <b-row
        cols-lg="3"
        cols-md="2"
        cols-sm="2"
        class="justify-content-center h-100 mx-0"
      >
        <b-col align-self="center">
          <b-card class="card-login">
            <b-dropdown
              class="language-dropdown mt-4"
              toggle-class="language-toggle"
              variant="light"
              right
              no-caret
            >
              <template #button-content>
                <b-icon icon="globe" aria-hidden="true" />
                <span class="sr-only">{{ copy.language }}</span>
              </template>

              <b-dropdown-item
                v-for="option in languageOptions"
                :key="option.value"
                :active="language === option.value"
                @click="language = option.value"
              >
                {{ option.text }}
              </b-dropdown-item>
            </b-dropdown>

            <b-img class="logo" alt="Vue logo" :src="logoSrc"></b-img>

            <b-form @submit.prevent="verifyOtp" class="px-3 pb-4">
              <div>
                <small class="text-white">{{ copy.otpSentTo }}</small>
                <div class="txt-white font-weight-bold">{{ maskedMsisdn }}</div>

                <div class="text-white mt-2">
                  {{ copy.expiredOtp }}
                  <span class="font-weight-bold">
                    {{ otpCountdownText }}
                  </span>
                </div>
              </div>

              <div>
                <div class="otp-row mt-4">
                  <input
                    v-for="(digit, idx) in otp"
                    :key="idx"
                    :ref="'otpInput' + idx"
                    class="otp-box mb-4"
                    type="text"
                    inputmode="numeric"
                    pattern="\\d*"
                    maxlength="1"
                    v-model="otp[idx]"
                    @input="onOtpInput(idx, $event)"
                    @keydown="onOtpKeydown(idx, $event)"
                    @paste.prevent="onOtpPaste($event)"
                  />
                </div>

                <b-button
                  v-if="!otpExpired"
                  variant="success"
                  block
                  class="mt-2 btn-confirm"
                  :disabled="isCellcardError0002"
                  @click.prevent="verifyOtp"
                >
                  {{ copy.confirm }}
                </b-button>

                <b-button
                  v-else
                  variant="success"
                  block
                  class="mt-2 btn-confirm"
                  :disabled="isCellcardError0002"
                  @click.prevent="requestOtp"
                >
                  {{ copy.ResendOtp }}
                </b-button>
              </div>
            </b-form>

            <div class="mt-3 text-center d-flex justify-content-center">
              <span v-if="copy.install" class="txt-white">
                {{ copy.install }}
                <a
                  @click.prevent="openInstallLink"
                  class="txt-white"
                  style="
                    cursor: pointer;
                    text-decoration: underline;
                    margin-left: 6px;
                  "
                >
                  {{ copy.esim }}
                </a>
              </span>
            </div>

            <!-- BUTTON SEND OTP -->
            <span id="otp-tooltip-target" style="display: none"></span>
            <b-modal id="error-modal" title="Error" hide-footer>
              <div class="mb-3">
                {{ this.errorMessage || "An unexpected error occurred." }}
              </div>
              <b-button variant="primary" block @click="onErrorModalClose"
                >Close</b-button
              >
            </b-modal>
            <b-tooltip
              ref="tooltip"
              target="otp-tooltip-target"
              :disabled.sync="disabled"
            >
              <div class="tooltip-custom">{{ copy.unsupported }}</div>
            </b-tooltip>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<!-- SCRIPT LOGIC SECTION -->
<script>
import { mapActions, mapState } from "vuex";
import { apiMsg } from "@/provider/index.js";
export default {
  data() {
    return {
      disabled: true,
      isCellcardError0002: false,
      redirectToLoginOnModalClose: false,
      language: "km",
      languageOptions: [
        { value: "en", text: "English" },
        // { value: "id", text: "Indonesia" },
        { value: "km", text: "កម្ពុជា" },
      ],
      translations: {
        en: {
          language: "Language",
          greeting: "Hi!",
          instruction: "To start playing, enter your mobile number here:",
          placeholder: "855xxxxx",
          login: "Login",
          unsupported: "This provider number is not supported.",
          install: "Need a cellcard phone number? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "Get eSIM",
          package: "Choose Package",
          otpSentTo: "OTP will be sent to",
          confirm: "Confirm",
          ResendOtp: "Resend OTP",
          confirmation: "Confirmation",
          enterPhoneNumber: "Enter Phone Number",
          expiredOtp: "OTP Expires in ",
          errorOtp: "Invalid OTP. Please try again",
          errorOtpFailed: "Failed to send OTP. Please try again.",
          errorOtpMaxFailed: "Your OTP has reach limit",
          errorExpired: "OTP is expired. Please try again",
        },
        id: {
          language: "Bahasa",
          greeting: "Hai!",
          instruction: "Untuk mulai main, masukkan nomor handphonemu di sini:",
          placeholder: "628xxxxxxxxx",
          login: "Login",
          unsupported: "Tidak mendukung nomor provider ini.",
          install: "",
          link: "",
          package: "Choose Package",
          otpSentTo: "OTP will be sent to",
          confirm: "Confirm",
          ResendOtp: "Kirim Ulang OTP",
          confirmation: "Confirmation",
          enterPhoneNumber: "Enter Phone Number",
          expiredOtp: "OTP Kadaluarsa pada ",
          errorOtp: "Invalid OTP. Please try again",
          errorOtpFailed: "Failed to send OTP. Please try again.",
          errorOtpMaxFailed: "Your OTP has reach limit",
          errorExpired: "OTP is expired. Please try again",
        },
        km: {
          language: "ភាសា",
          greeting: "",
          instruction: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",
          placeholder: "855xxxxxxxx",
          login: "ចូលគណនី",
          unsupported: "លេខរបស់ប្រតិបត្តិករនេះមិនត្រូវបានគាំទ្រទេ។",
          install: "តម្រូវការស៊ីមសែលកាតមែនទេ? ",
          link: "https://selfcareapp-links.cellcard.com.kh/?redirectTo=main/buyESim",
          esim: "ទិញ eSIM ឥឡូវនេះ",
          package: "សូមជ្រើសរើសកញ្ចប់",
          otpSentTo: "OTP នឹងត្រូវបានផ្ញើទៅ",
          confirm: "បញ្ជាក់",
          ResendOtp: "ផ្ញើ OTP ម្តងទៀត",
          confirmation: "បញ្ជាក់ការភ្ជាប់",
          enterPhoneNumber: "សូមបញ្ចូលលេខទូរស័ព្ទរបស់អ្នក",
          expiredOtp: "ផុតកំណត់ក្នុងរយៈពេល",
          errorOtp: "លេខ OTP មិនត្រឹមត្រូវ។ សូមព្យាយាមម្តងទៀត។",
          errorOtpFailed: "បរាជ័យក្នុងការផ្ញើ OTP។ សូមព្យាយាមម្តងទៀត។",
          errorOtpMaxFailed: "លេខកូដ OTP របស់អ្នកបានដល់កម្រិតកំណត់ហើយ។",
          errorExpired: "លេខកូដ OTP បានផុតកំណត់ហើយ។ សូមព្យាយាមម្តងទៀត។",
        },
      },
      msisdn: null,
      otp: ["", "", "", "", "", ""],

      otpCountdown: 300,
      otpTimer: null,
      otpExpired: false,
      isOtpSent: false,

      token: null,
      ws: null,
      form: {
        msisdn: null,
      },
      // subscription plans as requested
      subscription_plan: {
        daily: {
          name: "XGoal Daily",
          description: "Get full access",
          validity: "Validity: 1 day",
          price: "$0.10",
        },
        weekly: {
          name: "XGoal Weekly",
          description: "Get full access",
          validity: "Validity: 7 days",
          price: "$0.50",
        },
      },
      selectedPlan: null,
      telcos: null,
      isLoading: false,
      errorMessage: null,
      a_table:
        "00000000 77073096 EE0E612C 990951BA 076DC419 706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B 7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D 6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F 63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1 4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3 45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5 56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87 58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589 06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB 086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED 1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF 15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541 3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73 33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525 206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17 2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739 9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B 9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D 806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F 8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1 A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3 A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795 BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7 B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9 EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661 D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53 DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605 CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37 C30C8EA1 5A05DF1B 2D02EF8D",
      b_table: null,
    };
  },
  mounted() {
    let savedLanguage = null;
    try {
      savedLanguage = localStorage.getItem("loginLanguage");
    } catch (e) {
      console.warn("localStorage unavailable", e);
    }

    if (savedLanguage && this.translations[savedLanguage])
      this.language = savedLanguage;
    document.documentElement.lang = this.language;
    if (this.android && window.androidOrientation)
      window.androidOrientation.postMessage("portrait");
    this.b_table = this.a_table.split(" ").map(function (s) {
      return parseInt(s, 16);
    });
    // use MSISDN from previous login step
    this.msisdn =
      this.$store && this.$store.state ? this.$store.state.user : null;
    if (!this.msisdn) {
      // no MSISDN stored, go back to login
      this.$router && this.$router.push && this.$router.push({ name: "login" });
      return;
    }
    this.hideAlert();
    // automatically request OTP when this view loads
    if (this.msisdn) {
      this.requestOtp();
    }
  },
  computed: {
    ...mapState(["telco", "secretKey", "android"]),
    copy() {
      return (
        this.translations[this.language] ||
        this.translations.km ||
        this.translations.en
      );
    },
    logoSrc() {
      return require("@/assets/login-logo-kh.png");
    },
    fontClass() {
      if (this.language === "en") return "font-inter";
      if (this.language === "km") return "font-noto";
      return "";
    },
    maskedMsisdn() {
      const s = String(
        this.msisdn ||
          (this.$store && this.$store.state && this.$store.state.user) ||
          "",
      );
      if (!s) return "";
      if (s.length <= 6) return s;
      const first = s.slice(0, 4);
      const last = s.slice(-2);
      return `${first}•••${last}`;
    },
    otpCountdownText() {
      const minutes = Math.floor(this.otpCountdown / 60);
      const seconds = this.otpCountdown % 60;

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
        2,
        "0",
      )}`;
    },
  },
  watch: {
    language(value) {
      try {
        localStorage.setItem("loginLanguage", value);
      } catch (e) {
        console.warn("localStorage unavailable", e);
      }
      document.documentElement.lang = value;
    },
  },
  methods: {
    ...mapActions([
      "getProfile",
      // 'getGames',
    ]),
    async handleSubmit() {
      const msisdnInput = String(this.msisdn || "").replace(/\D/g, "");
      if (msisdnInput.length >= 7) {
        let msisdn = msisdnInput;
        if (msisdn.charAt(0) === "0") {
          msisdn = "855" + msisdn.substring(1);
        }

        this.msisdn = msisdn;
        this.$store.state.isLoading = true;
        const _token = btoa(msisdn);
        this.$store.state.user = msisdn;
        this.token = _token;

        // verify OTP via backend
        const code = (this.otp || []).join("");
        if (!code || code.length !== 6) {
          this.$bvToast &&
            this.$bvToast.toast &&
            this.$bvToast.toast("Enter a 6-digit OTP", { variant: "danger" });
          this.$store.state.isLoading = false;
          return;
        }

        try {
          const payload = { msisdn: msisdn, otp: code };
          await apiMsg.post("auth/otp/verify", payload);

          const deviceId = this.getDeviceId();
          const loginPayload = {
            msisdn: msisdn,
            device_id: deviceId,
          };
          const loginResponse = await apiMsg.post(
            "sessions/login",
            loginPayload,
          );

          if (
            loginResponse &&
            loginResponse.data &&
            loginResponse.data.data &&
            loginResponse.data.data.session_id
          ) {
            this.$store.commit(
              "SET_SESSION_USER",
              loginResponse.data.data.session_id,
            );

            this.$store.commit("SET_USER", msisdn);
            this.$store.commit("SET_PRE_USER", msisdn);
            this.$router.push({ name: "play" }).catch(() => {});

            // WEBSOCKET CONNECTION
            this.connectSessionSocket(loginResponse.data.data.session_id);
          }

          // this.$store.commit("SET_USER", null);
          // this.$store.commit("SET_PRE_USER", null);
          // this.$router.push({ name: "play" }).catch(() => {});
        } catch (err) {
          // this.errorMessage = this.copy.errorOtp;
          this.$store.state.isLoading = false;
          const errorMessage = err?.response?.data?.error || "";
          if (errorMessage.includes("cellcard subscribe error 0002")) {
            this.isCellcardError0002 = true;
            this.redirectToLoginOnModalClose = true;
            this.errorMessage = this.copy.errorOtp;
          } else if (
            errorMessage.includes("msisdn is suspended due to OTP fail limit")
          ) {
            this.isCellcardError0002 = true;
            this.redirectToLoginOnModalClose = true;
            this.errorMessage = this.copy.errorOtpMaxFailed;
          } else if (
            errorMessage.includes("cellcard confirm error 0003: FAILURE")
          ) {
            this.errorMessage = this.copy.errorExpired;
          } else if (errorMessage.includes("invalid or expired otp")) {
            this.errorMessage = this.copy.errorOtp;
          } else {
            this.errorMessage = this.copy.errorOtpFailed;
          }

          try {
            this.sendErrorLog({
              source: "OtpLogin",
              action: "verifyOtp",
              message: err && err.message ? err.message : String(err),
              stack: err && err.stack ? err.stack : null,
              msisdn: msisdn || null,
              route: (this.$route && this.$route.name) || null,
              lang: this.language || null,
              ua:
                (typeof navigator !== "undefined" && navigator.userAgent) ||
                null,
              timestamp: new Date().toISOString(),
            });
          } catch (logErr) {
            console.warn("Failed to send error log", logErr);
          }

          this.$bvModal &&
            this.$bvModal.show &&
            this.$bvModal.show("error-modal");
        }
        this.hideAlert();
      }
    },

    async requestOtp() {
      if (!this.msisdn) return;

      try {
        this.$store.state.isLoading = true;

        const payload = {
          msisdn: String(this.msisdn),
        };

        await apiMsg.post("auth/otp/cellcard", payload);

        this.isOtpSent = true;
        this.startOtpCountdown();
      } catch (err) {
        this.$store.state.isLoading = false;
        const errorMessage = err?.response?.data?.error || "";
        if (errorMessage.includes("cellcard subscribe error 0002")) {
          this.isCellcardError0002 = true;
          this.redirectToLoginOnModalClose = true;
          this.errorMessage = this.copy.errorOtp;
        } else if (
          errorMessage.includes("msisdn is suspended due to OTP fail limit")
        ) {
          this.isCellcardError0002 = true;
          this.redirectToLoginOnModalClose = true;
          this.errorMessage = this.copy.errorOtpMaxFailed;
        } else if (
          errorMessage.includes("cellcard confirm error 0003: FAILURE")
        ) {
          this.errorMessage = this.copy.errorExpired;
        } else if (errorMessage.includes("invalid or expired otp")) {
          this.errorMessage = this.copy.errorOtp;
        } else if (
          errorMessage.includes("cellcard confirm error 0005: FAILURE")
        ) {
          this.isCellcardError0002 = true;
          this.errorMessage = this.copy.errorOtpMaxFailed;
        } else {
          this.errorMessage = this.copy.errorOtpFailed;
        }

        // Send error details to backend for debugging
        try {
          const logPayload = {
            source: "OtpLogin",
            action: "requestOtp",
            message: err?.message || String(err),
            stack: err?.stack || null,
            status: err?.response?.status || null,
            responseData: err?.response?.data || null,
            msisdn: this.msisdn || null,
            route: this.$route?.name || null,
            lang: this.language || null,
            ua:
              (typeof navigator !== "undefined" && navigator.userAgent) || null,
            timestamp: new Date().toISOString(),
          };

          this.sendErrorLog(logPayload);
        } catch (logErr) {
          console.warn("Failed to prepare/send error log", logErr);
        }

        if (this.$bvModal?.show) {
          this.$bvModal.show("error-modal");
        }
      } finally {
        this.$store.state.isLoading = false;
      }
    },

    startOtpCountdown() {
      // Stop timer sebelumnya
      this.clearOtpCountdown();

      // Reset countdown ke 5 menit
      this.otpCountdown = 300;

      // Aktifkan kembali OTP
      this.otpExpired = false;

      this.otpTimer = setInterval(() => {
        if (this.otpCountdown > 0) {
          this.otpCountdown--;
        }

        if (this.otpCountdown <= 0) {
          this.otpCountdown = 0;
          this.otpExpired = true;
          this.clearOtpCountdown();
        }
      }, 1000);
    },

    clearOtpCountdown() {
      if (this.otpTimer) {
        clearInterval(this.otpTimer);
        this.otpTimer = null;
      }
    },

    onOtpInput(index, e) {
      const raw = (e.target && e.target.value) || "";
      const val = String(raw).replace(/\D/g, "").slice(-1);
      this.$set(this.otp, index, val);
      if (val && index < this.otp.length - 1) {
        let next = this.$refs["otpInput" + (index + 1)];
        if (Array.isArray(next)) next = next[0];
        if (next && typeof next.focus === "function") {
          next.focus();
          if (next.select) next.select();
        }
      }
      // if last digit and all filled, auto-verify
      const code = this.otp.join("");
      if (code.length === this.otp.length && this.otp.every((d) => d !== "")) {
        // VERIFY TO BE
        // setTimeout(() => this.verifyOtp(), 120);
      }
    },

    onOtpKeydown(index, e) {
      if (e.key === "Backspace") {
        if (!this.otp[index] && index > 0) {
          let prev = this.$refs["otpInput" + (index - 1)];
          if (Array.isArray(prev)) prev = prev[0];
          if (prev && typeof prev.focus === "function") prev.focus();
        } else {
          this.$set(this.otp, index, "");
        }
      }
      if (e.key === "ArrowLeft" && index > 0) {
        let prev = this.$refs["otpInput" + (index - 1)];
        if (Array.isArray(prev)) prev = prev[0];
        if (prev && typeof prev.focus === "function") prev.focus();
      }
      if (e.key === "ArrowRight" && index < this.otp.length - 1) {
        let next = this.$refs["otpInput" + (index + 1)];
        if (Array.isArray(next)) next = next[0];
        if (next && typeof next.focus === "function") next.focus();
      }
    },

    onOtpPaste(e) {
      const paste =
        (e.clipboardData || window.clipboardData).getData("text") || "";
      const digits = paste
        .replace(/\D/g, "")
        .slice(0, this.otp.length)
        .split("");
      for (let i = 0; i < digits.length; i++) {
        this.$set(this.otp, i, digits[i]);
        let ref = this.$refs["otpInput" + i];
        if (Array.isArray(ref)) ref = ref[0];
        if (ref && typeof ref.blur === "function") ref.blur();
      }
      // focus next empty or last
      let nextIndex =
        digits.length < this.otp.length ? digits.length : this.otp.length - 1;
      let next = this.$refs["otpInput" + nextIndex];
      if (Array.isArray(next)) next = next[0];
      if (next && typeof next.focus === "function") next.focus();
      const code = this.otp.join("");

      if (code.length === this.otp.length && !code.includes("")) {
        // VERIFY TO BE
        // setTimeout(() => this.verifyOtp(), 120);
      }
    },

    verifyOtp() {
      const code = (this.otp || []).join("");
      if (!code || code.length !== 6 || /\D/.test(code)) {
        this.$bvToast &&
          this.$bvToast.toast &&
          this.$bvToast.toast("Enter a 6-digit OTP", { variant: "danger" });
        return;
      }
      // TODO: verify OTP with backend. For now proceed to profile flow
      this.handleSubmit();
    },
    setStore() {
      this.$store.commit("SET_TOKEN", this.token);
      this.$store.commit("SET_USER", this.msisdn);
    },
    showAlert() {
      this.disabled = false;
      this.$refs.tooltip.$emit("open");
    },
    hideAlert() {
      this.disabled = true;
      this.$refs.tooltip.$emit("close");
    },
    openInstallLink() {
      const link = this.copy && this.copy.link;
      if (!link) return;
      try {
        window.open(link, "_blank", "noopener");
      } catch (e) {
        window.location.href = link;
      }
    },
    connectSessionSocket(sessionId, attempt = 0) {
      if (!sessionId || typeof WebSocket === "undefined") return;

      const INITIAL_TIMEOUT_MS = 10000;
      const MAX_RECONNECT_DELAY_MS = 30000;

      try {
        const baseUrl = (
          process.env.VUE_APP_API_BASE_URL_GO ||
          process.env.VUE_APP_API_GO ||
          ""
        ).replace(/\/$/, "");
        const wsBaseUrl = baseUrl.replace(/^http/, "ws");
        const wsUrl = `${wsBaseUrl}/sessions/ws?session_id=${encodeURIComponent(
          sessionId,
        )}`;

        if (attempt === 0) this.disconnectSessionSocket();
        this.ws = new WebSocket(wsUrl);

        let openTimeout = null;
        let socketDidOpen = false;

        const clearOpenTimeout = () => {
          if (openTimeout) {
            clearTimeout(openTimeout);
            openTimeout = null;
          }
        };

        const scheduleReconnect = (delay) => {
          clearOpenTimeout();
          setTimeout(() => {
            this.connectSessionSocket(sessionId, attempt + 1);
          }, delay);
        };

        openTimeout = setTimeout(() => {
          this.sendErrorLog({
            source: "OtpLogin",
            action: "websocketConnectionTimeout",
            message: "WebSocket did not open within timeout",
            sessionId: sessionId || null,
            attempt: attempt,
            wsUrl: wsUrl || null,
            route: (this.$route && this.$route.name) || null,
            ua:
              (typeof navigator !== "undefined" && navigator.userAgent) || null,
            timestamp: new Date().toISOString(),
          });
          try {
            this.ws.close();
          } catch (e) {
            // ignore
          }
          this.ws = null;
          scheduleReconnect(
            Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS),
          );
        }, INITIAL_TIMEOUT_MS);

        this.ws.onopen = () => {
          clearOpenTimeout();
          socketDidOpen = true;
          console.log("Session websocket connected");
        };

        this.ws.onmessage = (event) => {
          try {
            const message = JSON.parse(event.data || "{}");
            console.log(message);
            if (
              message.type === "force_logout" ||
              message.reason === "login_new_device"
            ) {
              this.handleForceLogout(
                message.message ||
                  "You have been logged out because your account logged in from a new device.",
              );
            }
          } catch (e) {
            console.warn("Failed to parse websocket message", e);
            this.sendErrorLog({
              source: "OtpLogin",
              action: "websocketMessageParse",
              message: e && e.message ? e.message : String(e),
              stack: e && e.stack ? e.stack : null,
              sessionId: sessionId || null,
              route: (this.$route && this.$route.name) || null,
              ua:
                (typeof navigator !== "undefined" && navigator.userAgent) ||
                null,
              timestamp: new Date().toISOString(),
            });
          }
        };

        this.ws.onerror = (error) => {
          clearOpenTimeout();
          console.warn("Session websocket error", error);
          this.sendErrorLog({
            source: "OtpLogin",
            action: "websocketError",
            message: "WebSocket error event fired",
            sessionId: sessionId || null,
            attempt: attempt,
            wsUrl: wsUrl || null,
            route: (this.$route && this.$route.name) || null,
            ua:
              (typeof navigator !== "undefined" && navigator.userAgent) || null,
            timestamp: new Date().toISOString(),
          });
        };

        this.ws.onclose = (event) => {
          clearOpenTimeout();
          this.ws = null;
          // If the socket never opened, keep trying silently. Mobile browsers
          // and WebViews can block the handshake temporarily; we do not want
          // to logout the user for that.
          if (!socketDidOpen) {
            scheduleReconnect(
              Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS),
            );
            return;
          }
          // Once the socket opened, an unclean close means the session may have
          // been terminated server-side. Reconnect so the user can keep playing
          // if it was just a network blip; the server will tell us to logout if
          // another device took over.
          if (!event.wasClean) {
            scheduleReconnect(
              Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS),
            );
          }
        };
      } catch (e) {
        console.warn("Failed to connect session websocket", e);
        this.sendErrorLog({
          source: "OtpLogin",
          action: "websocketConnectException",
          message: e && e.message ? e.message : String(e),
          stack: e && e.stack ? e.stack : null,
          sessionId: sessionId || null,
          attempt: attempt,
          route: (this.$route && this.$route.name) || null,
          ua: (typeof navigator !== "undefined" && navigator.userAgent) || null,
          timestamp: new Date().toISOString(),
        });
        setTimeout(() => {
          this.connectSessionSocket(sessionId, attempt + 1);
        }, Math.min(2000 * Math.pow(2, attempt), MAX_RECONNECT_DELAY_MS));
      }
    },
    disconnectSessionSocket() {
      if (this.ws) {
        try {
          this.ws.close();
        } catch (e) {
          // ignore
        }
        this.ws = null;
      }
    },
    handleForceLogout(message) {
      this.disconnectSessionSocket();
      this.$store.commit("SET_SESSION_USER", null);
      this.$store.commit("SET_USER", null);
      this.$store.commit("SET_PRE_USER", null);
      try {
        this.$bvModal &&
          this.$bvModal.show &&
          this.$bvModal.show("error-modal");
      } catch (e) {
        // ignore if modal not ready
      }
      this.errorMessage = message || "Your session has been logged out.";
      this.$router.push({ name: "login" }).catch(() => {});
    },
    getDeviceId() {
      // Prefer the native Android bridge exposed by the wrapper app.
      try {
        if (
          typeof window !== "undefined" &&
          window.androidDevice &&
          typeof window.androidDevice.getDeviceId === "function"
        ) {
          const nativeId = window.androidDevice.getDeviceId();
          if (nativeId) return String(nativeId);
        }
      } catch (e) {
        console.warn("Native device id retrieval failed", e);
      }

      // Fall back to a deterministic fingerprint derived from stable browser
      // signals. This is intentionally simple and avoids extra dependencies.
      const parts = [];
      if (typeof navigator !== "undefined") {
        parts.push(navigator.userAgent || "");
        parts.push(navigator.language || "");
        parts.push((navigator.platform || "").toString());
        parts.push((navigator.deviceMemory || "").toString());
        parts.push((navigator.hardwareConcurrency || "").toString());
        const screen = window.screen || {};
        parts.push([screen.width, screen.height, screen.colorDepth].join("x"));
      }
      const raw = parts.join("|");
      let hash = 0;
      for (let i = 0; i < raw.length; i++) {
        const char = raw.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      const fallbackId = Math.abs(hash).toString(16).padStart(12, "0");
      return `web-${fallbackId}`;
    },
    async sendErrorLog(payload) {
      if (!payload) return;
      try {
        await apiMsg.post("a/fe", { type: "frontend_error", payload });
      } catch (e) {
        // don't throw — logging failure should not affect user flow
        console.warn("sendErrorLog failed", e);
      }
    },
    purchasePlan(planKey) {
      const key = planKey || this.selectedPlan;
      if (!key) return;
      const plan = this.subscription_plan[key];
      console.log("Purchasing plan:", key, plan);
      // TODO: integrate payment / API call here
      try {
        this.$store.commit("SET_SELECTED_PLAN", { key, plan });
      } catch (e) {
        // ignore if mutation not available
      }
      this.$router
        .push({ name: "payment", query: { plan: key } })
        .catch(() => {});
    },
    b_crc32(str) {
      var crc = -1;
      for (var i = 0, iTop = str.length; i < iTop; i++) {
        crc = (crc >>> 8) ^ this.b_table[(crc ^ str.charCodeAt(i)) & 0xff];
      }
      return (crc ^ -1) >>> 0;
    },

    onErrorModalClose() {
      this.$bvModal.hide("error-modal");
      if (this.redirectToLoginOnModalClose) {
        this.redirectToLoginOnModalClose = false;
        this.$router.push({ name: "login" }).catch(() => {});
      }
    },
  },
};
</script>

<!-- STYLE SECTION -->
.style-font-imports { }
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&family=Noto+Sans+Khmer:wght@400;700&display=swap");

.content-login {
  min-height: 100vh;

  background-color: #0b40a2;

  background-image: linear-gradient(
      to top,
      rgba(0, 0, 0, 0.75) 0%,
      rgba(0, 0, 0, 0.45) 25%,
      rgba(0, 0, 0, 0.15) 50%,
      rgba(0, 0, 0, 0) 75%
    ),
    url("../assets/login-logo-mobile.png");

  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.card-login {
  background-color: transparent;
  border: none;
  position: relative;
}
.language-dropdown {
  position: absolute;
  right: 23px;
  top: 10px;
  z-index: 2;
}
.language-dropdown::v-deep .language-toggle {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  padding: 0;
  width: 42px;
}
.logo {
  height: 30vh;
  max-height: 320px;
  margin-top: 80px;
}
.txt-white {
  color: white;
}
.tooltip-custom {
  /* color: red !important; */
  font-size: 0.8rem !important;
  max-width: 300px !important;
  padding: 0.5rem !important;
}

.font-inter {
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
}

.font-noto {
  font-family: "Noto Sans Khmer", "Noto Sans", sans-serif;
}

.btn-confirm {
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 120ms ease;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
}

.plan-card {
  cursor: pointer;
  transition: box-shadow 160ms ease, transform 120ms ease;
  border: 1px solid rgba(255, 255, 255, 0.06);
}
.plan-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
}
.plan-card.selected {
  border-color: rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.45);
}

/* Reduce internal spacing for plan cards */
.plan-card .card-body {
  padding: 10px 12px !important;
}
.plan-card h5 {
  font-size: 1rem;
  margin-bottom: 6px;
}
.plan-card .small {
  margin-bottom: 4px;
}
.plan-card .btn {
  padding: 0.28rem 0.6rem;
  font-size: 0.85rem;
}

/* OTP input boxes */
.otp-row {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
.otp-box {
  width: 44px;
  height: 48px;
  text-align: center;
  font-size: 1.25rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.03);
  background-color: white;
  outline: none;
}
.otp-box:focus {
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.35);
  border-color: rgba(255, 255, 255, 0.3);
}
</style>
